import { useState } from 'react';
import { useMountEffect } from './useMountEffect';

export const useDeferredMount = () => {
  const [deferring, setDeferring] = useState(true);
  useMountEffect(() => {
    const id = requestIdleCallback(() => setDeferring(false));
    return () => cancelIdleCallback(id);
  });
  return deferring;
};

const requestIdleCallback = (callback: () => void) => {
  if ((global as any).requestIdleCallback) return (global as any).requestIdleCallback(callback);
  return setTimeout(() => {
    callback();
  }, 1);
};

const cancelIdleCallback = (id: any) => {
  if ((global as any).cancelIdleCallback) return (global as any).cancelIdleCallback(id);
  return clearTimeout(id);
};
